// All values come from VITE_* env vars (set in `.env` for local dev,
// or in Cloudflare Pages → Settings → Environment variables for prod).
// Fallbacks below are used when an env var is absent.
const env = import.meta.env;
const E = (key, fallback) => {
  const v = env[key];
  return v === undefined || v === "" ? fallback : v;
};

export const GIFT_CARD = {
  recipientName: E("VITE_RECIPIENT_NAME", "Ngô Thanh Tâm"),
  fromTeam: E("VITE_FROM_TEAM", "Đội ngũ NexDrop Express"),
  occasionDate: E("VITE_OCCASION_DATE", "29 tháng 4, 2026"),
  personalNote: E(
    "VITE_PERSONAL_NOTE",
    "Nhân dịp sinh nhật, NexDrop thân gửi đến Tâm những lời chúc tốt đẹp nhất. Chúc Tâm bước sang tuổi mới thật nhiều sức khỏe, luôn tràn đầy năng lượng và gặt hái thêm nhiều thành công rực rỡ. Cảm ơn Tâm vì sự đồng hành và những đóng góp quý báu cho công ty. Chúc Tâm có một ngày kỷ niệm thật trọn vẹn.",
  ),
  steamKey: E("VITE_STEAM_KEY", "X7K9P-2QM4N-8RT3W-5BVH6-LDJ8C"),
  steamPin: E("VITE_STEAM_PIN", "4827 1593"),
};

export const STRINGS = {
  pageTitle: E("VITE_PAGE_TITLE", "Quà sinh nhật · NexDrop"),
  headlineTitle: E(
    "VITE_HEADLINE_TITLE",
    'CHÚC MỪNG SINH NHẬT <span class="accent">NGÔ THANH TÂM!</span>',
  ),
  giftKind: E("VITE_GIFT_KIND", "Steam Credit Card"),
  forLabel: E("VITE_FOR_LABEL", "Dành tặng"),
  keyLabel: E("VITE_KEY_LABEL", "Mã Key"),
  pinLabel: E("VITE_PIN_LABEL", "Mã PIN"),
  helperLocked: E(
    "VITE_HELPER_LOCKED",
    "Lưu ý: chỉ mở khi bạn đã sẵn sàng nhập mã vào Steam.",
  ),
  revealButton: E("VITE_REVEAL_BUTTON", "Mở quà"),
  modalTitle: E("VITE_MODAL_TITLE", "Nhập mật khẩu để mở quà"),
  modalDesc: E(
    "VITE_MODAL_DESC",
    "Nhập mật khẩu được người tặng cung cấp để mở khoá mã quà tặng.",
  ),
  modalPlaceholder: E("VITE_MODAL_PLACEHOLDER", "Mật khẩu"),
  modalSubmit: E("VITE_MODAL_SUBMIT", "Mở khoá"),
  modalCancel: E("VITE_MODAL_CANCEL", "Huỷ"),
  modalError: E(
    "VITE_MODAL_ERROR",
    "Mật khẩu không đúng. Vui lòng thử lại.",
  ),
  revealPassword: E("VITE_REVEAL_PASSWORD", "nexdrop2026"),
  howtoTitle: E("VITE_HOWTO_TITLE", "Cách kích hoạt"),
  howtoStep1: E(
    "VITE_HOWTO_STEP_1",
    'Đăng nhập vào ứng dụng <a href="https://store.steampowered.com" target="_blank" rel="noreferrer">Steam</a> trên máy tính của bạn.',
  ),
  howtoStep2: E(
    "VITE_HOWTO_STEP_2",
    "Mở mục <strong>Trò chơi</strong> &rsaquo; <strong>Kích hoạt sản phẩm trên Steam…</strong> rồi nhập mã Key ở trên.",
  ),
  howtoStep3: E(
    "VITE_HOWTO_STEP_3",
    "Khi được hỏi, dán mã PIN để xác thực và hoàn tất.",
  ),
  toastCopiedPrefix: E("VITE_TOAST_COPIED_PREFIX", "Đã sao chép"),
};

export function mountGiftCard(card = GIFT_CARD, strings = STRINGS) {
  // Aggregate every binding key in one place
  const bindings = { ...strings, ...card };

  document.title = strings.pageTitle;

  document.querySelectorAll("[data-bind]").forEach((el) => {
    const key = el.dataset.bind;
    if (key in bindings) el.textContent = bindings[key];
  });

  document.querySelectorAll("[data-bind-html]").forEach((el) => {
    const key = el.dataset.bindHtml;
    if (key in bindings) el.innerHTML = bindings[key];
  });

  // Resolve copy-button aria-label/title from the localized label key
  document.querySelectorAll('[data-action="copy"]').forEach((btn) => {
    const labelKey = btn.dataset.labelKey;
    btn.dataset.label = bindings[labelKey] ?? "";
  });

  // ── Reveal interaction ──────────────────────────────────────
  let revealed = false;
  const fields = document.querySelectorAll("[data-field]");
  const ctaLocked = document.querySelector('[data-cta="locked"]');

  const setRevealed = (next) => {
    revealed = next;
    fields.forEach((f) => f.classList.toggle("is-locked", !next));
    ctaLocked.hidden = next;

    document.querySelectorAll('[data-action="copy"]').forEach((btn) => {
      btn.disabled = !next;
      const label = btn.dataset.label;
      btn.setAttribute(
        "aria-label",
        next ? `${strings.toastCopiedPrefix} ${label}` : `${label}`,
      );
      btn.title = next ? strings.toastCopiedPrefix : "";
      const icon = btn.querySelector("i");
      if (icon && !btn.classList.contains("copied")) {
        icon.className = next ? "ph ph-copy" : "ph ph-lock-key";
      }
    });
  };
  setRevealed(false);

  // ── Toast ───────────────────────────────────────────────────
  const toastEl = document.querySelector("[data-toast]");
  const toastMsg = document.querySelector("[data-toast-msg]");
  let toastTimer;
  const showToast = (msg) => {
    toastMsg.textContent = msg;
    toastEl.classList.add("is-visible");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove("is-visible"), 2000);
  };

  // ── Copy ────────────────────────────────────────────────────
  const copyText = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      return true;
    } catch {
      return false;
    }
  };

  document.querySelectorAll('[data-action="copy"]').forEach((btn) => {
    btn.addEventListener("click", async () => {
      if (!revealed) return;
      const target = btn.dataset.target;
      const ok = await copyText(card[target]);
      if (!ok) return;
      btn.classList.add("copied");
      const icon = btn.querySelector("i");
      icon.className = "ph-fill ph-check-circle";
      showToast(`${strings.toastCopiedPrefix} ${btn.dataset.label}`);
      setTimeout(() => {
        btn.classList.remove("copied");
        icon.className = "ph ph-copy";
      }, 1800);
    });
  });

  // ── Confetti ────────────────────────────────────────────────
  const confettiHost = document.querySelector("[data-confetti]");
  const palette = [
    "#00D4F0",
    "#00D4F0",
    "#00D4F0",
    "#F5A623",
    "#F5899B",
    "#8A38F5",
    "#24CC2A",
    "#141B1F",
  ];
  const launchConfetti = () => {
    confettiHost.replaceChildren();
    const frag = document.createDocumentFragment();
    for (let i = 0; i < 60; i++) {
      const piece = document.createElement("span");
      const left = Math.random() * 100;
      const dx = (Math.random() - 0.5) * 240;
      const rot = (Math.random() * 720 - 360) | 0;
      const dur = 2.2 + Math.random() * 1.6;
      const delay = Math.random() * 0.25;
      const w = 6 + Math.random() * 6;
      const h = 8 + Math.random() * 10;
      piece.style.left = left + "vw";
      piece.style.background = palette[i % palette.length];
      piece.style.width = w + "px";
      piece.style.height = h + "px";
      piece.style.animationDuration = dur + "s";
      piece.style.animationDelay = delay + "s";
      piece.style.setProperty("--dx", dx + "px");
      piece.style.setProperty("--rot", rot + "deg");
      frag.appendChild(piece);
    }
    confettiHost.appendChild(frag);
    setTimeout(() => confettiHost.replaceChildren(), 4200);
  };

  // ── Password modal ──────────────────────────────────────────
  const modal = document.querySelector("[data-modal]");
  const modalForm = document.querySelector("[data-modal-form]");
  const modalInput = document.querySelector("[data-modal-input]");
  const modalInputWrap = modal.querySelector(".modal-input-wrap");
  const modalError = document.querySelector("[data-modal-error]");
  const modalToggle = document.querySelector("[data-modal-toggle]");

  modalInput.placeholder = strings.modalPlaceholder;
  modalError.textContent = strings.modalError;

  let lastFocused = null;

  const openModal = (trigger) => {
    lastFocused = trigger;
    modal.hidden = false;
    modalError.hidden = true;
    modalInputWrap.classList.remove("is-error");
    modalInput.value = "";
    modalInput.type = "password";
    modalToggle.querySelector("i").className = "ph ph-eye";
    modalToggle.setAttribute("aria-label", "Hiện mật khẩu");
    document.body.style.overflow = "hidden";
    setTimeout(() => modalInput.focus(), 30);
  };

  const closeModal = () => {
    modal.hidden = true;
    document.body.style.overflow = "";
    lastFocused?.focus?.();
  };

  document
    .querySelector('[data-action="reveal"]')
    .addEventListener("click", (e) => openModal(e.currentTarget));

  modal.querySelectorAll("[data-modal-close]").forEach((el) => {
    el.addEventListener("click", closeModal);
  });

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && !modal.hidden) closeModal();
  });

  modalForm.addEventListener("submit", (e) => {
    e.preventDefault();
    if (modalInput.value === strings.revealPassword) {
      closeModal();
      setRevealed(true);
      launchConfetti();
    } else {
      modalError.hidden = false;
      modalInputWrap.classList.add("is-error");
      modalInput.focus();
      modalInput.select();
    }
  });

  modalInput.addEventListener("input", () => {
    if (!modalError.hidden) {
      modalError.hidden = true;
      modalInputWrap.classList.remove("is-error");
    }
  });

  modalToggle.addEventListener("click", () => {
    const showing = modalInput.type === "text";
    modalInput.type = showing ? "password" : "text";
    modalToggle.querySelector("i").className = showing
      ? "ph ph-eye"
      : "ph ph-eye-slash";
    modalToggle.setAttribute(
      "aria-label",
      showing ? "Hiện mật khẩu" : "Ẩn mật khẩu",
    );
  });
}
